import React, { useEffect, useMemo } from 'react';
// @ts-ignore
import parse from 'html-react-parser';
import ComentarioForm from '../../../../shared/components/ComentarioForm';
import SugestaoAquisicaoForm from '../../../../shared/components/SugestaoAquisicaoForm';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import ModalConstructor from '../../../../shared/components/ModalConstructor';
import { useParams } from 'react-router-dom';
import { createSanitizedInnerHTML } from '../../../../shared/utils/htmlSanitizer';


export type ModalViewType = null|'C'|'S'|'SP';
interface SuggestionsAndLinksModalProps {
    title: string|null;
    viewType: ModalViewType;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    instituicaoRx: {
        msg_suporte_consulta?: string
    }
}
const SuggestionsAndLinksModal: React.FC<SuggestionsAndLinksModalProps> = (props) => {
    const { title, viewType, isOpen, setIsOpen , instituicaoRx} = props;

    // eslint-disable-next-line react/display-name
    const getContent = useMemo(() => () => {
        switch (viewType){
            case 'C':
                return (
                    <ComentarioForm />
                )
            case 'S':
                return (
                    <SugestaoAquisicaoForm instituicaoRx={instituicaoRx} />
                )
            case 'SP':
                return (
                    <Row className="mb-3">
                        <Col>
                            <div>
                                {parse(createSanitizedInnerHTML(instituicaoRx?.msg_suporte_consulta ?? '').__html)}
                            </div>
                        </Col>
                    </Row>
                );
            default:
                return null;
        }
    }, [viewType,instituicaoRx])

    // @ts-ignore
    return (<ModalConstructor
            closeable
            closeAction
            size="xl"
            title={title}
            open={isOpen}
            setOpen={setIsOpen}
        >
            {getContent()}
        </ModalConstructor>
    )
}


const mapStateToProps = (state: any) => ({
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(SuggestionsAndLinksModal);
